import { createFileRoute } from '@tanstack/react-router';
import { Banknote, Building, Calendar, MessageCircle } from 'lucide-react';

export const Route = createFileRoute('/_app/settings/integrations')({
  component: IntegrationsPage,
});

function IntegrationsPage() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">Integraciones</h1>
        <p className="mt-1 text-sm text-[color:var(--color-fg-muted)]">
          Conexiones con servicios externos y APIs de terceros.
        </p>
      </header>

      <div
        className="rounded-lg border p-5 text-sm"
        style={{
          background: 'var(--color-bg-overlay)',
          borderColor: 'var(--color-border)',
        }}
      >
        <strong>Próximamente.</strong> Cada integración requiere su propio
        flow de OAuth/API keys. Acá vas a poder conectar y revocar.
      </div>

      <section className="grid gap-3 sm:grid-cols-2">
        <IntegrationCard
          icon={<Calendar className="h-5 w-5" />}
          name="Google Calendar"
          status="planned"
          detail="Sincronizá tareas con SLA al calendario del ejecutivo."
        />
        <IntegrationCard
          icon={<MessageCircle className="h-5 w-5" />}
          name="WhatsApp Business"
          status="planned"
          detail="Recepción de mensajes de clientes + envío proactivo."
        />
        <IntegrationCard
          icon={<Building className="h-5 w-5" />}
          name="SII Chile (API)"
          status="planned"
          detail="Validación RUT, emisión DTE, descarga F29."
        />
        <IntegrationCard
          icon={<Banknote className="h-5 w-5" />}
          name="Bancos (cartolas)"
          status="planned"
          detail="Conciliación automática Scotiabank, BCI, Estado, Santander."
        />
      </section>
    </div>
  );
}

interface IntegrationCardProps {
  readonly icon: React.ReactNode;
  readonly name: string;
  readonly status: 'planned' | 'connected' | 'available';
  readonly detail: string;
}

function IntegrationCard({ icon, name, status, detail }: IntegrationCardProps) {
  return (
    <div
      className="flex gap-3 rounded-lg border p-4"
      style={{
        background: 'var(--color-bg-elevated)',
        borderColor: 'var(--color-border)',
      }}
    >
      <div
        className="shrink-0 rounded-md p-2"
        style={{ background: 'var(--color-bg-overlay)', color: 'var(--color-fg-muted)' }}
      >
        {icon}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">{name}</span>
          <StatusBadge status={status} />
        </div>
        <div className="mt-0.5 text-xs text-[color:var(--color-fg-muted)]">{detail}</div>
      </div>
    </div>
  );
}

const STATUS_LABEL: Record<IntegrationCardProps['status'], string> = {
  planned: 'Planeado',
  available: 'Disponible',
  connected: 'Conectado',
};

function StatusBadge({ status }: { readonly status: IntegrationCardProps['status'] }) {
  return (
    <span
      className="inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide"
      style={{
        background: 'var(--color-bg-overlay)',
        color: 'var(--color-fg-muted)',
      }}
    >
      {STATUS_LABEL[status]}
    </span>
  );
}
